import { LevelPool } from '@trustpad/launchpad';
import * as React from 'react';
import { Popup } from '~common/components/Popup';
import { levelPools } from '~config/levelPoolsConfig';
import { getCompoundAPY, getLongTermBonus, YEAR } from '~features/tiers/utils';
import { fNum } from '~utils';
import { StakingPoolAllocationBoosters } from './StakingPoolAllocationBoosters';

export function StakingPoolMainNumbers({
  stakingConfig,
}: {
  stakingConfig: LevelPool;
}) {
  const compoundAPY =
    stakingConfig.lockPeriodSeconds >= YEAR
      ? getCompoundAPY(stakingConfig.apy, stakingConfig.lockPeriodSeconds)
      : 0;
  const longTermBonus = getLongTermBonus(
    Math.min(...levelPools.map((p) => p.apy).filter(Boolean)),
    stakingConfig.apy,
    stakingConfig.lockPeriodSeconds,
  );

  return (
    <>
      {false && (
        <div className="flex items-end justify-between gap-6 flex-wrap mb-4 mt-4">
          <div className="text-center flex-shrink-0">
            <div>
              <span
                className={`${
                  compoundAPY ? 'brand-text' : 'text-gray-600'
                } text-3xl`}>
                {compoundAPY
                  ? `${fNum(Math.round(compoundAPY), 0)}%`
                  : '< 1 year'}
              </span>{' '}
              <CompoundHelpPopup />
            </div>
            <div className="text-muted leading-none text-sm">
              Compounded Interest
            </div>
          </div>
          {stakingConfig.lockPeriodSeconds >=
            levelPools.find((p) => p.id === '180 days').lockPeriodSeconds && (
            <div className="text-center flex-shrink-0">
              <div>
                <span className="brand-text text-3xl">
                  {fNum(Math.round(longTermBonus), 0)}%
                </span>
                <LongTermHelpPopup />
              </div>
              <div className="text-muted leading-none text-sm">
                Loyalty Bonus
              </div>
            </div>
          )}
        </div>
      )}

      <div className="flex items-end justify-center gap-6 flex-wrap">
        <StakingPoolAllocationBoosters config={stakingConfig} />
      </div>
    </>
  );
}

function CompoundHelpPopup() {
  return (
    <Popup containerClassName="ml-1" header="Compounded Interest">
      <p>
        Compounded interest is calculated with weekly re-stakings for the
        complete staking period of 365, 730 or 1095 days. The percentages are
        rounded to the nearest integers.
      </p>
    </Popup>
  );
}

function LongTermHelpPopup() {
  return (
    <Popup containerClassName="ml-1" header="Loyalty Bonus">
      <p>
        The longer you stake with a higher APY, the more you will earn in the
        long term. The Long-Term Bonus percentage shows the difference between
        the 14 days staking rewards versus the longer-term staking rewards.
      </p>
      <p>The formulas for the Long-Term Bonuses:</p>
      <p>
        Compound interest of the 14 days pool rewards in the days of the
        selected staking pool / Compound interest of the selected pool rewards
        in the days of the selected staking pool = Long-Term Bonus percentage
      </p>
      <p>For instance:</p>
      <p>
        Compound interest of the 14 days pool rewards in 730 days / Compound
        interest of the 730 days pool rewards in 730 days = Long-Term Bonus
        percentage
      </p>
    </Popup>
  );
}
